import LoginContentContainer from "./LoginContent.redux";
import React from "react";

const LoginContent: React.FC = () => <LoginContentContainer />;

export default LoginContent;
